import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  FormGroup,
  Label,
  Input,
  Alert,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  Col,
} from "reactstrap";
import "../../assets/css/EditRecordModal.css";

const EditRecordModal = ({
  isOpen,
  onClose,
  record,
  categories,
  updateRecord,
  allLanguages,
  decreaseVideoCount,
  increaseVideoCount,
}) => {
  const [disabled, setDisabled] = useState(true);
  const [isDropDownOpen, setIsDropDownOpen] = useState(false);
  const [isLanguageDropDownOpen, setIsLanguageDropDownOpen] = useState(false);

  const [error, setError] = useState(null);
  const [title, setTitle] = useState(record.title);
  const [category, setCategory] = useState(record.category);
  const [categoryID, setCategoryID] = useState(record.categoryID);
  //   const [topic, setTopic] = useState(record.topic);
  const [language, setLanguage] = useState(record.language);
  // const [duration, setDuration] = useState(record.duration);
  const [videoID, setVideoID] = useState(record.videoID);
  const [description, setDescription] = useState(record.description);
  const [tag, setTag] = useState(record.tags);
  const [timestamp, setTimestamp] = useState(record.timestamp.seconds);
  const [inputFieldsName, setInputFieldsName] = useState([]);
  // const languages = ["English", "Hindi"];

  useEffect(() => {
    const values = [...inputFieldsName];
    Object.entries(record).map((item) => {
      if (
        item[0] !== "UserID" &&
        item[0] !== "id" &&
        item[0] !== "categoryID" &&
        item[0] !== "category" &&
        item[0] !== "timestamp" &&
        item[0] !== "premiumVideo" &&
        item[0] !== "language" &&
        item[0] !== "tags" &&
        item[0] !== "title" &&
        item[0] !== "videoID"
      ) {
        values[item[0]] = item[1];
        setInputFieldsName(values);
      }
    });
  }, []);

  useEffect(() => {
    if (title && category && description && tag && videoID && language) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [title, category, description, tag, videoID, language]);

  const submitHandler = async (e) => {
    e.preventDefault();
    setDisabled(true);
    var tagArray = record.tags;
    if (tag != record.tags) {
      tagArray = tag.split(",");
    }
    if (categoryID != record.categoryID) {
      await decreaseVideoCount(record.categoryID);
      await increaseVideoCount(categoryID);
    }

    // const newRecord = {
    //   title,
    //   category,
    //   description,
    //   tags: tagArray,
    //   videoID,
    //   language,
    //   duration,
    // };
    updateRecord({
      ...inputFieldsName,
      tags: tagArray,
      language,
      category,
      categoryID,
      title,
      videoID,
    });
  };

  const handleTimeChange = (date) => {
    const newTimestamp = new Date(date).getTime() / 1000;
    setTimestamp(newTimestamp);
  };

  const handleUpdation = (fieldName, fieldValue) => {
    const values = { ...inputFieldsName };
    values[fieldName] = fieldValue;
    setInputFieldsName(values);
  };

  const handleCategoryOption = (id, category) => {
    setCategoryID(id);
    setCategory(category);
  };

  return (
    <div>
      <Modal centered isOpen={isOpen} toggle={onClose}>
        <ModalHeader
          toggle={onClose}
          close={
            <button
              style={{ width: "auto", padding: "3px 7px", background: "red" }}
              onClick={onClose}
            >
              x
            </button>
          }
        >
          Update Record
        </ModalHeader>
        <ModalBody style={{ height: "545px", overflowY: "scroll" }}>
          {error && <Alert color="danger">{error}</Alert>}
          <Form>
            <FormGroup>
              <Label for="title">Title</Label>
              <Input
                id="title"
                type="text"
                name="title"
                placeholder="Title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </FormGroup>
            <Row form>
              <Col>
                <FormGroup>
                  <Label>Category</Label>
                  <Dropdown
                    size="sm"
                    isOpen={isDropDownOpen}
                    toggle={() => setIsDropDownOpen(!isDropDownOpen)}
                  >
                    <DropdownToggle caret color="info">
                      {category || "Select"}
                    </DropdownToggle>
                    <DropdownMenu
                      modifiers={{
                        setMaxHeight: {
                          enabled: true,
                          order: 890,
                          fn: (data) => {
                            return {
                              ...data,
                              styles: {
                                ...data.styles,
                                overflow: "auto",
                                maxHeight: 100,
                                width: "100%",
                              },
                            };
                          },
                        },
                      }}
                    >
                      {categories.map(({ id, category }) => (
                        <span key={id}>
                          <DropdownItem
                            onClick={() => handleCategoryOption(id, category)}
                          >
                            {category}
                          </DropdownItem>
                          <DropdownItem divider />
                        </span>
                      ))}
                    </DropdownMenu>
                  </Dropdown>
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label for="language">Language</Label>
                  <Dropdown
                    id="language"
                    size="sm"
                    isOpen={isLanguageDropDownOpen}
                    toggle={() =>
                      setIsLanguageDropDownOpen(!isLanguageDropDownOpen)
                    }
                  >
                    <DropdownToggle caret color="warning">
                      {language || "Select"}
                    </DropdownToggle>
                    <DropdownMenu
                      modifiers={{
                        setMaxHeight: {
                          enabled: true,
                          order: 890,
                          fn: (data) => {
                            return {
                              ...data,
                              styles: {
                                ...data.styles,
                                overflow: "auto",
                                maxHeight: 100,
                                width: "100%",
                              },
                            };
                          },
                        },
                      }}
                    >
                      {allLanguages.map((language) => (
                        <span key={language}>
                          <DropdownItem onClick={() => setLanguage(language)}>
                            {language}
                          </DropdownItem>
                          <DropdownItem divider />
                        </span>
                      ))}
                      <FormGroup
                        style={{ textAlign: "center", fontWeight: "900" }}
                      >
                        <Label for="other">Other</Label>
                        <Input
                          id="other"
                          type="text"
                          name="language"
                          placeholder="Enter Language"
                          onChange={(e) => setLanguage(e.target.value)}
                        />
                      </FormGroup>
                    </DropdownMenu>
                  </Dropdown>
                </FormGroup>
              </Col>
            </Row>
            {Object.entries(inputFieldsName).map((item, index) => {
              return (
                <FormGroup key={item[0]}>
                  <Label for={item[0]}>
                    {typeof item[0] === "string" &&
                      item[0].charAt(0).toUpperCase() + item[0].slice(1)}
                  </Label>
                  <Input
                    id={item[0]}
                    type={
                      item[0] === "description" ? "textarea" : typeof item[1]
                    }
                    name={item[0]}
                    placeholder={item[0]}
                    value={item[1]}
                    onChange={(e) => handleUpdation(item[0], e.target.value)}
                  />
                </FormGroup>
              );
            })}

            {/* <FormGroup>
              <Label for="language">Language</Label>
              <Input
                id="language"
                type="text"
                name="language"
                placeholder="Enter Language"
                value={language}
                onChange={(e) => setLanguage(e.target.value)}
              />
            </FormGroup> */}

            {/* <FormGroup>
              <Label for="description">Description</Label>
              <Input
                id="description"
                type="textarea"
                name="description"
                placeholder="Description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </FormGroup>
            <FormGroup>
              <Label for="duration">Duration</Label>
              <Input
                id="duration"
                type="time"
                name="duration"
                value={duration}
                onChange={(e) => setDuration(e.target.value)}
              />
            </FormGroup>
           }
            {/* NOTE: ADD TOPIC Field to video */}
            {/* <FormGroup>
							<Label>Topic</Label>
							<Dropdown
								size="sm"
								isOpen={isDropDownOpenTopic}
								toggle={() =>
									setIsDropDownOpenTopic(!isDropDownOpenTopic)
								}
							>
								<DropdownToggle caret>
									{topic || "Select"}
								</DropdownToggle>
								<DropdownMenu
									modifiers={{
										setMaxHeight: {
											enabled: true,
											order: 890,
											fn: data => {
												return {
													...data,
													styles: {
														...data.styles,
														overflow: "auto",
														maxHeight: 100
													}
												};
											}
										}
									}}
								>
									{categories.map(({ id, topic }) => (
										<DropdownItem
											key={id}
											onClick={() =>
												setTopic(topic)
											}
										>
											{topic}
										</DropdownItem>
									))}
								</DropdownMenu>
							</Dropdown>
						</FormGroup> */}
            <FormGroup>
              <Label for="videoID">Video Id</Label>
              <Input
                id="videoID"
                type="text"
                name="videoID"
                placeholder="Video Id"
                value={videoID}
                onChange={(e) => setVideoID(e.target.value)}
              />
            </FormGroup>
            <FormGroup>
              <Label for="tags">Tags</Label>
              <Input
                id="tags"
                type="text"
                name="tags"
                placeholder="Enter tags separated by commas (,)"
                value={tag}
                onChange={(e) => setTag(e.target.value)}
              />
            </FormGroup>
            <FormGroup>
              <Label for="timestamp">Timestamp</Label>
              <div>
                <DatePicker
                  selected={new Date(timestamp * 1000)}
                  timeInputLabel="Time:"
                  onChange={handleTimeChange}
                  dateFormat="dd/MM/yyyy hh:mm aa"
                  showTimeInput
                  className="date-picker"
                />
              </div>
            </FormGroup>
            <Button disabled={disabled} color="primary" onClick={submitHandler}>
              Update
            </Button>
            <div />
          </Form>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default EditRecordModal;
